/* Bhaddie PDP — sticky buy bar + scroll reveals.
   No mobile nav here: the theme header owns navigation on Shopify. */
(() => {
  // NB: the buy-box section and the folds section each render their own
  // .bhaddie-pdp wrapper, so everything below queries the document.
  if (!document.querySelector('.bhaddie-pdp')) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- sticky buy bar ---------- */
  const bar   = document.getElementById('bhaddie-buybar');
  const form  = document.querySelector('form[data-type="add-to-cart-form"]');
  const cta   = form && form.querySelector('.product-form__submit');

  if (bar && cta) {
    const btn = bar.querySelector('.buybar__btn');
    btn.addEventListener('click', () => {
      document.getElementById('buy')?.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });

    // mirror the real button's state
    const sync = () => {
      const label = cta.querySelector('span')?.textContent.trim() || 'Add to cart';
      const sold  = cta.disabled;
      btn.disabled = sold;
      btn.textContent = sold ? label : 'Subscribe';
      const meta = bar.querySelector('.buybar__meta');
      const chosen = [...document.querySelectorAll('variant-selects input:checked')].map(i => i.value);
      if (meta) meta.textContent = chosen.join(' · ') + (sold ? ' · sold out' : '');
    };
    document.addEventListener('variant:changed', (e) => {
      const price = bar.querySelector('.buybar__price');
      if (price && e.detail) {
        price.textContent = (e.detail.price / 100).toLocaleString(undefined,
          { style: 'currency', currency: window.Shopify?.currency?.active || 'USD',
            minimumFractionDigits: 0 }) + '/month';
      }
      sync();
    });
    sync();

    let ticking = false;
    const onScroll = () => {
      const passed = cta.getBoundingClientRect().bottom < 0;
      const final  = document.querySelector('.bhaddie-pdp .final');
      const atEnd  = final ? final.getBoundingClientRect().top < innerHeight - 40 : false;
      bar.classList.toggle('is-on', passed && !atEnd);
      ticking = false;
    };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } },
      { passive: true });
    onScroll();
  }

  /* ---------- gallery: thumbnails swap the hero ----------
     The Liquid port rendered data-full on each thumb but never bound the
     click; that logic only existed in the standalone draft. */
  const hero = document.getElementById('hero');
  const thumbs = document.querySelectorAll('.gal__thumbs button');
  if (hero && thumbs.length) {
    thumbs.forEach((btn) => {
      btn.addEventListener('click', () => {
        const full = btn.dataset.full;
        if (!full || hero.getAttribute('src') === full) return;

        thumbs.forEach((b) => b.setAttribute('aria-current', b === btn ? 'true' : 'false'));

        if (reduce) { hero.src = full; return; }
        // swap straight away — waiting for the full image to download first
        // left the old photo on screen for as long as the request took.
        // Fade out, swap, fade back in once it has painted.
        hero.classList.add('swapping');
        // the hero is rendered with a srcset; the browser paints from that,
        // so setting src alone changes the attribute and nothing on screen.
        hero.removeAttribute('srcset');
        hero.removeAttribute('sizes');
        hero.src = full;
        const done = () => hero.classList.remove('swapping');
        hero.complete ? setTimeout(done, 60)
                      : hero.addEventListener('load', done, { once: true });
      });
    });
  }

  /* ---------- scroll reveals ---------- */
  if (reduce || !('IntersectionObserver' in window)) return;

  const tag = (sel, variant, stagger = 0, cap = 420) =>
    document.querySelectorAll('.bhaddie-pdp ' + sel).forEach((el, i) => {
      el.classList.add('r', variant);
      if (stagger) el.style.setProperty('--d', Math.min(i * stagger, cap) + 'ms');
    });

  tag('section h2, section .lede, .seclabel', 'r--head');
  tag('.kit__card', 'r--pop', 90);
  tag('.kit__rule, .egs li', 'r--left', 45);
  tag('#inside figure', 'r--right');
  tag('.quote figure', 'r--left');
  tag('.quote blockquote, .quote cite, .quote .stars', 'r--right', 80);
  tag('.sizerun li', 'r--pop', 55);
  tag('.sizenote li', 'r--up', 70);
  tag('.bag', 'r--pop', 80);
  tag('.rsum', 'r--drop');
  tag('.rev', 'r--pop', 70);
  tag('.perk', 'r--drop', 90);
  tag('.drop', 'r--up', 90);
  tag('.contact', 'r--up', 80);
  tag('.mailer, .pay', 'r--up');
  tag('.band__in > div', 'r--pop', 90);

  const io = new IntersectionObserver((entries, obs) => {
    entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('in'); obs.unobserve(en.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
  document.querySelectorAll('.bhaddie-pdp .r').forEach((el) => io.observe(el));
})();
